// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__AdditionalInfoToPurchasePagePolChange__displayNone{display:none}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-gateway-policychange-pa-react/pages/AdditionalInfoToPurchase/AdditionalInfoToPurchasePagePolChange.module.scss"],"names":[],"mappings":"AAAA,yDACI,YAAA","sourcesContent":[".displayNone {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"displayNone": "app__AdditionalInfoToPurchasePagePolChange__displayNone"
};
export default ___CSS_LOADER_EXPORT___;
